import React from 'react';
import {
  runConsentModeChecks,
  type GcmReport,
  type GcmCheck,
} from '../../diagnostics/consentMode.js';

export function GcmCard(props: { gcm: GcmReport | null; setGcm: (g: GcmReport) => void }) {
  const { gcm, setGcm } = props;
  return (
    <div className="rounded-lg border p-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Google Consent Mode v2</h2>
      {!gcm ? (
        <div className="text-sm text-gray-500">Collecting signals…</div>
      ) : (
        <div className="space-y-2">
          <div className="text-sm text-gray-600">
            Region: <code>{gcm.region ?? 'unknown'}</code> · GPC:{' '}
            <code>{gcm.gpc === null ? 'unknown' : String(gcm.gpc)}</code> · gtag:{' '}
            <code>{String(gcm.gtagPresent)}</code> · dataLayer:{' '}
            <code>{String(gcm.dataLayerPresent)}</code>
          </div>
          {import.meta.env.MODE !== 'production' && (
            <div className="flex gap-2">
              <button
                className="px-2 py-1 border rounded"
                onClick={() => {
                  try {
                    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
                    w.gtag?.('consent', 'default', {
                      ad_storage: 'denied',
                      ad_user_data: 'denied',
                      ad_personalization: 'denied',
                      analytics_storage: 'denied',
                    });
                    w.gtag?.('consent', 'update', {
                      ad_storage: 'denied',
                      ad_user_data: 'denied',
                      ad_personalization: 'denied',
                      analytics_storage: 'denied',
                    });
                    const rgn = (window as unknown as { __cmpRegion?: string }).__cmpRegion ?? null;
                    setGcm(runConsentModeChecks({ region: rgn }));
                  } catch {
                    /* noop */
                  }
                }}
              >
                Simulate Reject
              </button>
              <button
                className="px-2 py-1 border rounded"
                onClick={() => {
                  try {
                    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
                    w.gtag?.('consent', 'update', {
                      ad_storage: 'granted',
                      ad_user_data: 'granted',
                      ad_personalization: 'granted',
                      analytics_storage: 'granted',
                    });
                    const rgn = (window as unknown as { __cmpRegion?: string }).__cmpRegion ?? null;
                    setGcm(runConsentModeChecks({ region: rgn }));
                  } catch {
                    /* noop */
                  }
                }}
              >
                Simulate Accept
              </button>
            </div>
          )}
          <ul className="space-y-1">
            {gcm.checks.map((c: GcmCheck) => (
              <li key={c.id} className="flex items-start gap-2 text-sm">
                <span
                  className={`inline-block h-2 w-2 rounded-full ${c.ok ? 'bg-green-500' : 'bg-red-500'}`}
                />
                <div>
                  <div className="font-medium">{c.title}</div>
                  {c.detail && <div className="text-xs text-gray-600">{c.detail}</div>}
                  {!c.ok && c.fix && <div className="text-xs text-amber-700">Fix: {c.fix}</div>}
                </div>
              </li>
            ))}
          </ul>
          <details className="mt-2">
            <summary className="cursor-pointer text-sm">Raw snapshots</summary>
            <pre className="text-xs overflow-auto p-2 bg-gray-50 rounded">
              {JSON.stringify({ pre: gcm.preConsent, post: gcm.postConsent }, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
}
